import IState from '../state';

const setIsLoading = (state: IState, { isLoading }: any): IState => ({
  ...state,
  isLoading,
});

export default setIsLoading;
